<template>
  <div id="buypointsrecord">
    <div class="inner">
      <div class="ft20 " style="height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;border-bottom:dashed 1px rgba(151,151,151,0.5);padding-bottom:8px;">购买记录</div>
      <div class="record">
        <el-table :data="tableData" slot="append"  stripe header-row-class-name="record-th" style="width: 100%">
          <el-table-column label="积分变动" width="317">
            <p slot-scope="scope">
              <span class="" style="font-size: 13px;
font-family: MicrosoftYaHei;
color: #12B1BF;">+{{scope.row.point}}</span>
              <!-- {{$store.state.name}} -->
            </p>
          </el-table-column>
          <el-table-column label="支付金额" width="317">
            <p slot-scope="scope">
              <span class="theme-col">￥{{scope.row.money}}</span>
            </p>
          </el-table-column>
          <el-table-column label="交易时间">
            <p slot-scope="scope">
              <span class="theme-col">{{times(scope.row.add_time)}}</span>
            </p>
          </el-table-column>
          <div slot="empty" style="padding:20px 0;">
            <img src="/static/img/integral.png" alt="" style="width: 142px;height: 146px;">
            <p>暂无{{$store.state.name}}变动记录</p>
          </div>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        // {
        //     point:'34',
        //     add_time:'32423432424324',
        //     money:'4523',
        // },
        // {
        //     point:'34',
        //     add_time:'32423432424324',
        //     money:'4523',
        // },
      ]
    };
  },
  methods: {
    getdata() {
      this.$api.post(
        "user/wechat/buylist",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == 100) {
            this.tableData = res.data.data;
          }
        }
      );
    },
    times:function (timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m
        if(date.getMinutes()<10){
          m='0'+date.getMinutes()+':'
        }else{
          m = date.getMinutes()+':';
        }
        var s
        if(date.getSeconds()<10){
          s='0'+date.getSeconds()
        }else{
          s = date.getSeconds();
        }
        return Y+M+D+h+m+s;
      },
  },
  mounted() {
    this.getdata();
  }
};
</script>

<style lang="less" scoped>
#buypointsrecord {
  width: 977px;
  min-height: 605px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .inner {
    padding: 10px 30px;
    .record {
      margin-top: 20px;

      border: 1px solid #e3e3e3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/buypointsrecord.vue